import React from "react";

import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import { Chip } from "@mui/material";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import mainStyles from "styles";

interface UserOrgsCountChipProps {
  orgsCount: number;
  identityID?: string;
  showUsersWithOneOrg?: boolean;
}

const formatUserOrgsCount = (orgsCount: number) => {
  if (orgsCount < 0) {
    return "N/A";
  }
  if (orgsCount == 1) {
    return "1 organisation";
  }
  return `${orgsCount} organisations`;
};

const UserOrgsCountChip = ({
  orgsCount,
  identityID = "",
  showUsersWithOneOrg = false,
}: UserOrgsCountChipProps) => {
  const classes = mainStyles();
  const history = useHistory();

  // Don't show single-org users to avoid noise
  if (!showUsersWithOneOrg && orgsCount === 1) {
    return <></>;
  }

  return (
    <>
      <Chip
        size="small"
        color="error"
        className={clsx(
          classes.spaceLeftXSmall,
          classes.spaceRightXSmall,
          classes.redWine
        )}
        icon={<SwitchAccountIcon />}
        label={formatUserOrgsCount(orgsCount)}
        clickable={identityID.length > 0}
        onClick={() => {
          if (identityID.length > 0) {
            history.push(`/identity/${identityID}`);
          }
        }}
        data-testid="user-orgs-count-chip"
      />
    </>
  );
};

export default UserOrgsCountChip;
